import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { subDays, format } from 'date-fns';

import {
  Container,
  PageTitleContainer,
  PageTitle,
  Content,
  OrderIcon,
  ContainerItems,
  HeaderContainer,
  HeaderMobileContainer,
  IconLoading,
} from './styles';

import { NextPage, NextPageContainer } from '~/pages/Bankslips/styles';
import caminhao from '~/assets/images/Caminhao_Cinza.svg';
import api from '~/services/api';
import ItemList from '~/components/pages/OrderList/ItemList';
import Loading from '~/components/layout/Loading';
import { analytics, logEvent }  from "~/services/firebaseConfig";
import SideBar from '~/components/layout/Sidebar';
import Header from '~/components/layout/Header';
import HeaderMobile from '~/components/layout/HeaderOld';
import BackPage from '~/components/layout/BackPage';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import ModalEdit from "~/components/pages/OrderList/ModalEdit";
import OpenChatBot from '~/components/layout/Chatbot';
import { handleStatusText } from '~/utils/functions/mapperStatusOrder';

export default function ListStatus() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [orders, setOrders] = useState([]);
  const [ordersInView, setOrdersInView] = useState([]);
  const [orderChoosed, setOrderChoosed] = useState(null);
  const [loadingPage, setLoadingPage] = useState(true);
  const [notNext, setNotNext] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);
  const [ordersIndex, setOrdersIndex] = useState(0);
  const [indexToCompare, setIndexToCompare] = useState(10);
  const [lengthBelow20, setLengthBelow20] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const roles = useSelector(state => state.rolesReducer.roles);
  const economicGroupReducer = useSelector(
    (state) => state.economicGroupReducer
  );
  const orderEditReducer = useSelector(state => state.orderEditReducer);

  function activeModal(condition) {
    if (!condition) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  }

  function modifyArrayStatus(arr) {
    let modifyArr = []
    arr.map(element => {
      let newStatus = handleOrderCycle(
        handleStatusText(element.status),
        element.occupationStatus ? element.occupationStatus : null
      );
      modifyArr.push({
        creationDate: element.creationDate,
        cutDate: element.cutDate,
        cycleStatus: element.cycleStatus,
        statusInView: newStatus,
        deliveryDate: element.deliveryDate,
        id: element.id,
        number: element.number,
        occupationStatus: element.occupationStatus,
        products: element.products,
        serviceType: element.serviceType,
        shipping: element.shipping,
        source: element.source,
        status: element.status,
        supplyBranche: element.supplyBranche,
        supplyBrancheId: element.supplyBrancheId
      })
      return modifyArr;
    })
    return modifyArr
  }

  const setViewOrder = (data, index, resetRequest) => {
    if (data.length < 20 && data !== 0) {
      data = modifyArrayStatus(data)
      setOrdersInView(data);
      dispatch({ type: "IMUT_ORDERS", ordersEdit: data });
      setLengthBelow20(true);
    } else {
      setLengthBelow20(false);
      let usedData = resetRequest ? [] : orders;
      let newIndex = resetRequest ? 0 : ordersIndex;
      let indexToCompareVar = indexToCompare;
      if (orders.length < 1 || resetRequest) {
        usedData = data;
      }
      if (indexToCompareVar < index) {
        indexToCompareVar = index;
        setIndexToCompare(index);
      }
      let arrayToOrdersInView = [];
      if (resetRequest && indexToCompareVar >= 10) {
        setIndexToCompare(10);
        while (newIndex < 10) {
          arrayToOrdersInView.push(usedData[newIndex]);
          newIndex++;
        }
      } else {
        while (newIndex < indexToCompareVar) {
          if(usedData.length > newIndex) {
            arrayToOrdersInView.push(usedData[newIndex]);
          } else {
            setNotNext(true);
          }
          newIndex++;
        }
      }
      setOrdersIndex(newIndex);
      arrayToOrdersInView = modifyArrayStatus(arrayToOrdersInView)
      let concatArray = resetRequest ? [].concat(arrayToOrdersInView) : ordersInView.concat(arrayToOrdersInView);
      setOrdersInView(concatArray);
      dispatch({ type: "IMUT_ORDERS", ordersEdit: concatArray });
      setLoadingNext(false);
    }
  };

  const handleOrderCycle = (status, occupationStatus) => {
    switch (status.toLowerCase()) {
      case 'pedido recebido aguardando análise':
        return "PEDIDO RECEBIDO AGUARDANDO ANÁLISE"
      case 'em análise pelo financeiro':
        return "EM ANÁLISE PELO FINANCEIRO"
      case 'aguardando aprovação da logística':
        return "AGUARDANDO APROVAÇÃO DA LOGÍSTICA"
      case 'pedido com restrição':
        return "PEDIDO COM RESTRIÇÃO"
      case 'pedido liberado pelo financeiro':
        return occupationStatus ? occupationStatus : status
      case 'pedido cancelado':
        return "PEDIDO CANCELADO"
      default:
        return null
    }
  };

  const getOrders = () => {
    const currentDate = new Date();
    const startDate = subDays(currentDate, 60);
    const formattedStartDate = format(startDate, 'yyyy-MM-dd');

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const storeId = localStorage.getItem('storeId');
    const url = `/residential/order/v1/orders-ga?store-id=${storeId}&start-date=${formattedStartDate}`;
    api
      .get(url, parameters)
      .then(async res => {
        let settingOrders = [res.data];
        setOrders(settingOrders[0]);
        dispatch({ type: 'SET_ORDERS', orders: res.data });
        setViewOrder(settingOrders[0], 0, true);
        setLoadingPage(false);
      })
      .catch(err => {
        const HTTP_STATUS_NOT_FOUND = 404;
        const HTTP_STATUS_BAD_GATEWAY = 502;

        switch (err & err?.response?.status) {
          case HTTP_STATUS_NOT_FOUND:
            toast.error("Não há pedidos disponíveis");
            break;
          case HTTP_STATUS_BAD_GATEWAY:
            toast.error("Ocorreu algum erro");
            break;
          default:
            toast.error("Os pedidos de abastecimento não estão disponíveis na sua região");
            break;
          }

        setLoadingPage(false);
        history.push("/portal");
      });
  };

  const loadNextPage = () => {
    if (ordersIndex >= orders.length) {
      logEvent(analytics, 'status_de_pedido_carregar_mais');
      setNotNext(true);
    } else {
      logEvent(analytics, 'status_de_pedido_carregar_mais');
      setLoadingNext(true);
      let newIndex = indexToCompare + 10;
      setIndexToCompare(newIndex);
      setViewOrder(0, newIndex, false);
    }
  };

  useEffect(() => {
    setLoadingPage(true);
    setNotNext(false);
    setLoadingPage(true);
    setOrdersIndex(0);
    setIndexToCompare(10);
    setOrders([]);
    dispatch({ type: 'SET_ORDERS', orders: [] });
    setViewOrder([], 0);
    getOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [economicGroupReducer.selectedStore, orderEditReducer.orderEdited]);

  return (
    <SideBar menuSelected={'Início'}>
      {verifyRoles(roles, 'STATUS_DO_PEDIDO') ? (
        <>
          <HeaderContainer>
            <Header />
          </HeaderContainer>
          <Container>
            <HeaderMobileContainer>
              <HeaderMobile />
            </HeaderMobileContainer>
            <Content>
              <BackPage page="/portal" />
              <PageTitleContainer>
                <OrderIcon src={caminhao} alt="Ícone de caminhão" />
                <PageTitle>Histórico de pedidos</PageTitle>
              </PageTitleContainer>
              <ModalEdit
                order={orderChoosed}
                showModal={showModal}
                activeModal={activeModal}
              />
              {loadingPage ? (
                <Loading />
              ) : (
                <ContainerItems>
                  {ordersInView.map(element => (
                    <ItemList
                      key={element.id}
                      order={element}
                      ordersInView={ordersInView}
                      setOrderChoosed={setOrderChoosed}
                      activeModal={activeModal}
                    />
                  ))}
                  {lengthBelow20 ? null : (
                    <NextPageContainer content="center">
                      {notNext ? null : (
                        <NextPage onClick={() => loadNextPage()}>
                          {loadingNext ? (
                            <IconLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                          ) : (
                            'Carregar mais...'
                          )}
                        </NextPage>
                      )}
                    </NextPageContainer>
                  )}
                </ContainerItems>
              )}
            </Content>
          </Container>
        </>
      ) : (
        <Redirect to="/portal" />
      )}
      <OpenChatBot />
    </SideBar>
  );
}
